"use client";

import { useEffect } from "react";
import { getLenis } from "@/components/SmoothScrollProvider";

export default function useLockScroll(lock: boolean) {
  useEffect(() => {
    const lenis = getLenis();

    if (lock) {
      lenis?.stop();
    } else {
      lenis?.start();
    }

    return () => {
      lenis?.start();
    };
  }, [lock]);
}
